import {Badge, Navbar, Nav, Container, NavDropdown} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {FaBookOpen, FaMobileAlt, FaShoppingBasket, FaUser} from "react-icons/fa";
import NavbarCollapse from "react-bootstrap/NavbarCollapse";
import logo from "../assets/logo.png";
import {LinkContainer} from 'react-router-bootstrap';
import {useSelector, useDispatch} from "react-redux";
import {useLogoutMutation} from "../slices/usersApiSlice";
import {logout} from "../slices/authSlice";
import {useEffect, useState} from "react";
import SearchBox from "./SearchBox";
import {resetCart} from "../slices/cartSlice";
import FilterDropdown from './FilterDropdown';
import MobileNavbar from './MobileNavbar';


const Header = () => {
    const {cartItems} = useSelector((state) => state.cart);
    const {userInfo} = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isSticky, setIsSticky] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [logoutApiCall] = useLogoutMutation();

    useEffect(() => {
        const threshold = document.getElementById('nav-dropdownThree')?.offsetHeight || 0;

        const handleScroll = () => {
            if (window.scrollY > threshold) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const header = document.querySelector('.sticky');
        if (header) {
            setHeaderHeight(header.offsetHeight);
        }
    }, [isSticky]);

    const logoutHandler = async () => {
        console.log("Logout handler called");
        try {
            await logoutApiCall().unwrap();
            dispatch(logout());
            dispatch(resetCart());
            navigate('/login');
        } catch (err) {
            console.log(err);
        }
    };

    const handleMouseEnter = () => {
        setIsOpen(true);
    };

    const handleMouseLeave = () => {
        setIsOpen(false);
    };

    return (
        <header>
            <style>{`
                /* Hide desktop header on mobile */
                @media (max-width: 1199px) {
                    .desktop-header-only {
                        display: none !important;
                    }
                }

                /* Hamburger icon styling */
                .navbar-toggler {
                    border-color: #3E6D9C !important;
                }

                .navbar-toggler-icon {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%233E6D9C' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
                }
            `}</style>

            {/* Blue bar - mobile only */}
            <div className="mobile-blue-bar"></div>

            {/* MOBILE NAVBAR - Shows only on mobile */}
            <MobileNavbar />

            {/* Orange strip - mobile only */}
            <div className="mobile-orange-strip"></div>

            {/* DESKTOP HEADER - Shows only on desktop */}
            <div className="desktop-header-only">
                {/* Top contact bar */}
                <div style={{
                    borderTop: '2px solid #3E6D9C',
                    backgroundColor: '#3E6D9C',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingRight: '20px'
                }} id='nav-dropdownThree'>
                    <LinkContainer to="/Contact" style={{backgroundColor: '#3E6D9C'}}>
                        <Navbar.Brand style={{fontSize: '0.4rem'}}>
                            <FaMobileAlt/> Contact us
                        </Navbar.Brand>
                    </LinkContainer>
                    <LinkContainer to="/Help" style={{marginLeft: '20px'}}>
                        <Navbar.Brand>
                            <FaBookOpen/> Help
                        </Navbar.Brand>
                    </LinkContainer>
                    <Navbar style={{backgroundColor: "#FFF", borderTop: '10px solid #3E6D9C'}} variant="light"/>
                </div>

                <div className="header-wrapper" style={{height: isSticky ? `${headerHeight}px` : 'auto'}}>
                    <div className={isSticky ? 'sticky' : ''}>
                        <Navbar expand="xl" collapseOnSelect style={{backgroundColor: 'white'}} >
                            <Container>
                                <LinkContainer to="/" id='nav-dropdown'>
                                    <Navbar.Brand>
                                        <img src={logo} alt="RetroDayz" style={{ opacity: 1.0 }}/>
                                    </Navbar.Brand>
                                </LinkContainer>
                                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                                <Navbar.Collapse id="responsive-navbar-nav">
                                    <Nav className="ms-auto">
                                        {/* Search Box */}
                                        <div className="parent-container">
                                            <SearchBox  />
                                        </div>

                                        {/* Admin Dropdown */}
                                        {userInfo && userInfo.isAdmin && (
                                            <Nav.Link>
                                                <div style={{color: "#000000"}}>
                                                    <NavDropdown
                                                        title={
                                                            <span>
                                                                Admin <i className="fas fa-chevron-down" style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }}></i>
                                                            </span>
                                                        }
                                                        id='nav-dropdown'
                                                        className="nav-dropdown"
                                                    >
                                                        <LinkContainer to='/admin/orderlist'>
                                                            <NavDropdown.Item>Orders</NavDropdown.Item>
                                                        </LinkContainer>
                                                        <LinkContainer to='/admin/productlist'>
                                                            <NavDropdown.Item>Products</NavDropdown.Item>
                                                        </LinkContainer>
                                                        <LinkContainer to='/admin/userlist'>
                                                            <NavDropdown.Item>Users</NavDropdown.Item>
                                                        </LinkContainer>
                                                        <LinkContainer to='/admin/promocodelist'>
                                                            <NavDropdown.Item>🎟️ Promo Codes</NavDropdown.Item>
                                                        </LinkContainer>
                                                        <LinkContainer to='/admin/faire-import'>
                                                            <NavDropdown.Item>📦 CSV Import</NavDropdown.Item>
                                                        </LinkContainer>
                                                        <LinkContainer to='/admin/stock-updates'>
                                                            <NavDropdown.Item>🔄 Stock Updates</NavDropdown.Item>
                                                        </LinkContainer>
                                                    </NavDropdown>
                                                </div>
                                            </Nav.Link>
                                        )}

                                        {/* Desktop: Account, Basket and Filter side-by-side */}
                                        <Nav.Link className="desktop-basket-filter-container">
                                            <div style={{display: 'flex', alignItems: 'center', gap: '1rem', color: "#000000"}}>
                                                {/* Account/Login */}
                                                {userInfo ? (
                                                    <div style={{display: 'flex', alignItems: 'center', gap: '0.3rem'}}>
                                                        <FaUser style={{fontSize: '0.9rem'}} />
                                                        <NavDropdown
                                                            title={
                                                                <span>
                                                                    {userInfo.name} <i className="fas fa-chevron-down" style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }}></i>
                                                                </span>
                                                            }
                                                            id='nav-user-dropdown-desktop'
                                                            className="nav-dropdown"
                                                            onMouseEnter={handleMouseEnter}
                                                            onMouseLeave={handleMouseLeave}
                                                        >
                                                            <LinkContainer to='/profile'>
                                                                <NavDropdown.Item>My Account</NavDropdown.Item>
                                                            </LinkContainer>
                                                            <LinkContainer to='/wishlist'>
                                                                <NavDropdown.Item>Wishlist</NavDropdown.Item>
                                                            </LinkContainer>
                                                            <LinkContainer to='/orders'>
                                                                <NavDropdown.Item>Order History </NavDropdown.Item>
                                                            </LinkContainer>
                                                            <NavDropdown.Item onClick={logoutHandler}>
                                                                Logout
                                                            </NavDropdown.Item>
                                                        </NavDropdown>
                                                    </div>
                                                ) : (
                                                    <LinkContainer to='/login' style={{textDecoration: 'none', color: 'inherit'}}>
                                                        <div style={{cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.3rem'}}>
                                                            <FaUser style={{fontSize: '0.9rem'}} /> Account
                                                        </div>
                                                    </LinkContainer>
                                                )}

                                                {/* Basket */}
                                                <LinkContainer to="/cart" style={{textDecoration: 'none', color: 'inherit'}}>
                                                    <div style={{cursor: 'pointer'}}>
                                                        <FaShoppingBasket className="basket-icon" /> Basket
                                                        {
                                                            cartItems.length > 0 && (
                                                                <Badge pill bg='success' style={{marginLeft: '5px'}}>
                                                                    { cartItems.reduce((a,c) => a + c.qty, 0) }
                                                                </Badge>
                                                            )
                                                        }
                                                    </div>
                                                </LinkContainer>

                                                {/* Filter */}
                                                <FilterDropdown />
                                            </div>
                                        </Nav.Link>
                                    </Nav>
                                </Navbar.Collapse>
                            </Container>
                        </Navbar>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;